import { useState } from "react";
import GlobalContext from "./GlobalContext"

const GlobalState=(props)=>{

    const[first_name, set_first_name]=useState('')
    const[last_name, set_last_name]=useState('')
    const[email, set_email]=useState('')
    const[phone, set_phone]=useState('')
    const[password, set_password]=useState('')
    const[image, set_image]=useState('')
    const[is_logged_in, set_is_logged_in]=useState(false)
    const[token, set_token]=useState(sessionStorage.getItem("token") != null && sessionStorage.getItem("token") != undefined && sessionStorage.getItem("token") != '' ? sessionStorage.getItem("token") : '')
    const[base_url, set_base_url]=useState('http://localhost:8000/api/')

    const value={
        first_name, set_first_name,
        last_name, set_last_name,
        email, set_email,
        image, set_image,
        is_logged_in, set_is_logged_in,
        password,set_password,
        phone,set_phone,
        token, set_token,
        base_url
    }
    
    return (
        <>
        <GlobalContext.Provider value={value}>
            {props.children}
        </GlobalContext.Provider>
        </>
    )
}

export default  GlobalState;